export default __webpack_public_path__ + "img/menu.b34383d7.svg";